import paymentPluginStore from "./store/paymentStore";
import PaymentWidgetWithoutStore from "./components/PaymentWidgetWithoutStore";
import IndexationParametersWidgetWithoutStore from "./components/IndexationParametersWidgetWithoutStore";
import DiscountParametersWidgetWithoutStore from "./components/DiscountParametersWidgetWithoutStore";

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install(Vue, options) {
    if (!options || !options.store) {
      throw new Error('Please initialise plugin with a Vuex store.');
    }

    options.store.registerModule('paymentPlugin', paymentPluginStore);

    Vue.component('PaymentWidgetWithoutStore', PaymentWidgetWithoutStore);
    Vue.component('IndexationParametersWidgetWithoutStore', IndexationParametersWidgetWithoutStore);
    Vue.component('DiscountParametersWidgetWithoutStore', DiscountParametersWidgetWithoutStore);
  },
};
